<section
  [id]="anchorLink"
  class="center-text__section"
  [style.background]="sectionBackgroundColor"
>
  <div class="center-text__container">
    <div class="center-text__text" [style.color]="textColor">
      @if (supertitle && isFirstSection) {
        <h1 class="center-text__text__supertitle" [bindHTML]="supertitle"></h1>
      }
      @if (supertitle && !isFirstSection) {
        <h2 class="center-text__text__supertitle" [bindHTML]="supertitle"></h2>
      }

      @if (!supertitle && title && isFirstSection) {
        <h1 class="center-text__text__title" [bindHTML]="title"></h1>
      } @else {
        <h2 class="center-text__text__title" [bindHTML]="title"></h2>
      }

      @if (subtitle) {
        <h3 class="center-text__text__subtitle" [bindHTML]="subtitle"></h3>
      }

      @if (description) {
        <div>
          <div
            class="center-text__text__description"
            [bindHTML]="description"
          ></div>
        </div>
      }
    </div>
  </div>
</section>
